import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import SlickPayIco from 'assets/images/SlickPayComingSoon.png';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCalendarMode, selectCurrentSalonId } from 'selectors/currentSalon.selectors';

import CN from './ComingSoon.module.scss';

const ComingSoon = ({ variant, calendarMode, salonId }) => {
  const { t } = useTranslation();

  return (
    <div
      data-bem="ComingSoon"
      className={cn(
        {
          'banner-cashup': !variant || variant === 'normal',
          'banner-reports': variant === 'big',
        },
        CN[calendarMode],
      )}
    >
      <div className={CN.left}>
        <img src={SlickPayIco} alt={t('composite.comingSoon.imgAlt')} className={CN.ico} />
        <div className={CN.text}>
          <strong>
            {t('composite.comingSoon.descriptionPart1')}
            {S.space}
          </strong>{' '}
          {t('composite.comingSoon.descriptionPart2')}
          {S.space}
          {S.space}
          <NavLink
            to={`/salon/${salonId}/slickpay`}
            activeClassName="active"
            className={cn(CN.link, CN[calendarMode])}
            data-bem="ComingSoon__link"
          >
            {t('composite.comingSoon.learnMore')}
          </NavLink>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  calendarMode: selectCurrentSalonCalendarMode(state),
});

const ComingSoonHoc = connect(mapStateToProps)(ComingSoon);

export default ComingSoonHoc;
